
import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Table } from 'react-bootstrap';
import { FormGroup, TextInput, CurrencyInput, DropDown, InputGroup, DateInput } from '../../../../../../../../../components/form/form';
import SecurityForm from'./security-form';
import SecurityInfo from '../../../../../../../../../models/securityInfo';
import Loading from '../../../../../../../../../components/loading/loading';

import styles from './security-information.module.scss';
import addButton from '../../../../../../../../../assets/add-button-colored.svg';
import Listing from '../../../../../../../../../models/listing';

import { useValidation } from '../../../../../../../../../hooks/use-validation';
import { offerPeriodObj, offerPeriodValidator, offerPeriodValidatorPublished, securityTypeAndFormValidator } from '../../../../../../../../../form-control/listing-form/security-info-control';
import {toCurrency} from "../../../../../../../../../helpr/helper";

const MultipleSecurityForm = ({listingInfo, saveListingInfo, nextStep}) => {
  const validatorObj = listingInfo.isPublished? offerPeriodValidatorPublished: offerPeriodValidator;
  console.log(validatorObj);
  const offerPeriodState = useValidation(validatorObj, offerPeriodObj(listingInfo.offerPeriod), {border: '1px solid red'});
  const [ securityListBuffer, setSecurityListBuffer ] = useState(listingInfo.securityList);
  const { getField, getTextFieldProps, setDynamicField, validate } = offerPeriodState;
  const [ formStatus, setFormStatus ] = useState({
    submitted: false,
    formInvalid: false
  })

  /*
    Build date for caldendar constraints Advance date by 1 day (forward date)
    and remove constraint if termsheet is already published.
  */
  const today = new Date();
  today.setDate(today.getDate() + 1);
  const dateToday = listingInfo.isPublished? null: [
    today.getFullYear(),
    ('0'+ parseInt(today.getMonth() +1).toString()).slice(-2),('0'+today.getDate()).slice(-2)
  ].join('-');

  const headers = [
    'Long Name',
    'Short Name',
    'Issue Country',
    'Issue Currency',
    'Listing Date',
    'Maturity Date',
    'Issue Amount',
    'Amount Outstanding',
    'Tenor',
    'Issue Price',
    'Redemption Price'
  ]

  const setSecurityList = (array) => {
    const listingObj = {
      ...listingInfo,
      securityList: array
    }
    saveListingInfo(listingObj);
    setSecurityListBuffer(array);
  }

  useEffect(()=>{
    if(listingInfo.securityList.length === 0){
      listingInfo.securityList.push(new SecurityInfo())
    }
  },[])

  const nextHandler = (step) => {
    if(step){ nextStep(step) }
    else{
      // Validate Offer Period
      const { isFormValid, formState } = validate();
      if( isFormValid ){
        // Collect All Valid Security
        let validSecurities = [];
        let formInvalidFlag = false;
        console.log(listingInfo.securityList);
        for(let index in listingInfo.securityList){
          if(listingInfo.securityList[index].save){
            console.log(listingInfo.securityList[index]);
            validSecurities.push(listingInfo.securityList[index]);
          }
        }
        if( validSecurities.length < 2 ){
          formInvalidFlag = true;
          setFormStatus({ submitted: true, formInvalid: true })
        }
        else{ setFormStatus({ submitted: true, formInvalid: false }) }
        if( !formInvalidFlag ){
          setSecurityList(validSecurities);
          saveListingInfo(formState);
          nextStep();
        }
      }
    }
  }

  const addSecurity = () => {
    const array = [ ...listingInfo.securityList ].concat( new SecurityInfo() );
    setSecurityList(array);
  }

  const deleteSecurity = (index) => {
    let array = [ ...listingInfo.securityList ];
    array.splice(index, 1);

    const indexExists = (eData, index) => {
      if(index === null){ return true; }
      let flag = false;
      if(eData.role === 'SellingAgent'){
        eData.allocation.map(data=>{
          if(data.securityIndex.toString() === index.toString()){flag = true};
        });
      }
      if(eData.role === 'MarketMaker'){
        return eData.securitySubscription.includes(index.toString());
      }
      return flag;
    }

    const participantList = listingInfo.participantList.filter((data)=>
      ! ['SellingAgent','MarketMaker'].includes(data.role)
      // ||( (['SellingAgent','MarketMaker'].includes(data.role)) && !indexExists(data, index) )
    );

    saveListingInfo({...listingInfo, participantList: participantList, securityList: array});
    setSecurityListBuffer(array);
  }

  const buildRedemptionDetail = (data) => {
    let retVal = '';
    const rdetail = data['redemptionDetail'];

    for(let index in rdetail){
      retVal += rdetail[index]['optional_redemption_date'] + ' with the price of ' + rdetail[index]['optional_redemption_price'] + '.'
    }
    return retVal;
  }

  const renderSecurityListTable = () => {
    return (
      <Row>
        <Col>
          <FormGroup header="SUMMARY">
            <Table className="mt-1" responsive>
              <thead>
                <tr>
                  {headers.map((header, index)=>{
                    return <th key={'table-'+index}>{header}</th>})}
                </tr>
              </thead>
              <tbody>
                { listingInfo.securityList.map((data,index)=>{
                    if(data['save']){
                      return (
                        <tr key={'secf-'+index}>
                          <td className={styles['def-width']}>{data['longName']}</td>
                          <td className={styles['def-width']}>{data['prefShortName']}</td>
                          <td className={styles['def-width']}>{data['countryOfIssue']}</td>
                          <td>{data['currency']}</td>
                          <td className={styles['def-width']}>{data['listingDate']}</td>
                          <td className={styles['def-width']}>{data['maturityDate']}</td>
                          <td>{toCurrency(data['amount'])}</td>
                          <td>{toCurrency(data['amountOutstanding'])}</td>
                          <td>{data['tenor']}</td>
                          <td>{data['issuePrice']}</td>
                          <td>{data['redemptionPrice']}</td>
                          {/*<td>{buildRedemptionDetail(data)}</td>*/}
                        </tr>
                      )
                    }
                })}
              </tbody>
            </Table>
          </FormGroup>
        </Col>
      </Row>
    )
  }

  const saveSecurityInfo = (index, securityInfo) => {
    const info = {
      ...securityInfo,
      save: true
    }
    const array = [ ...listingInfo.securityList ];
    array[index] = info;
    setSecurityList(array);
  }


  const renderAddButton = () => {
    if( !listingInfo.isPublished ) {
      return (
        <div className={styles['btn-actions']}>
          <div onClick={()=>addSecurity()} className={styles['add-btn']}>
            <img src={addButton}/>
          </div>
        </div>
      )
    }
    return (
      <div className={styles['btn-actions']}>
        <div className={styles['add-btn-disabled']}>
          <img src={addButton}/>
        </div>
      </div>
    )
  }

  return (
    <div className={styles['security-information-component']}>
      { renderSecurityListTable() }
      {
        securityListBuffer.map((data, index)=>{
          const secInfo = _.cloneDeep(data);
          return <SecurityForm
                  key={"sec-info-"+index}
                  index={index}
                  securityListBuffer={securityListBuffer}
                  securityInfo={secInfo}
                  saveSecurityInfo={saveSecurityInfo}
                  deleteSecurity={deleteSecurity}
                  isPublished={listingInfo.isPublished}/>
        })
      }
      { renderAddButton() }
      <InputGroup header="OFFER PERIOD" style={{marginBottom: '30px'}}>
        <Row className="mt-1">
          <Col sm={6} lg={3}>
            <DateInput inputProps={getTextFieldProps('offerPeriodFrom')} min={dateToday}>
              From:*
            </DateInput>
          </Col>
          <Col sm={6} lg={3}>
            <DateInput inputProps={getTextFieldProps('offerPeriodTo')} min={getField('offerPeriodFrom')}>
              To:*
            </DateInput>
          </Col>
        </Row>
      </InputGroup>
      { ( formStatus.submitted && formStatus.formInvalid ) && <div className={styles['err-msg']}> There should be at least 2 securities to proceed. </div> }
      <div className={styles['btn-actions']}>
        <Button onClick={()=>nextHandler(true)} className="btn-secondary">BACK</Button>
        <Button onClick={()=>nextHandler()}>NEXT</Button>
      </div>
    </div>
  )
}

export default MultipleSecurityForm;
